import { Component, inject, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { DefaultComponent } from "@kpx/core";
import { QuickscanService } from "@kpx/quickscan";
import { filter } from "rxjs";

@Component({
  selector: "app-services-dialog",
  imports: [MatIconModule],
  templateUrl: "./services-dialog.component.html",
  styleUrl: "./services-dialog.component.less",
})
export class ServicesDialogComponent extends DefaultComponent implements OnInit {
  private dialogRef: MatDialogRef<unknown>;
  public quickscan: QuickscanService;
  public portalUrl: string | null;
  public appName: string | null;

  public constructor() {
    super();
    this.dialogRef = inject(MatDialogRef);
    this.quickscan = inject(QuickscanService);
    this.portalUrl = null;
    this.appName = location.host.split(".").shift() ?? null;
  }

  public ngOnInit(): void {
    this.addSubscription(
      this.dialogRef.beforeClosed().subscribe(() => this.close()),
      this.quickscan.config.pipe(filter((c) => !!c)).subscribe((c) => (this.appName = c.dok.name)), //(this.portalUrl = c.PORTAL_URL),
    );
  }

  public close(): void {
    location.reload();
  }

  public returnPortal(): void {
    if (this.portalUrl) window.location.href = this.portalUrl;
  }
}
